import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import OnePageLayout from "../../components/layout/OnePageLayout";
import {
  Btns,
  ButtonL,
  CheckBoxWrap,
  Content,
  ImgWrap,
  InputsDiv,
  Section,
  TextDiv,
} from "../../styles/Common";
import { styled } from "styled-components";
import { ReactComponent as OrBar } from "../../styles/images/or_bar.svg";
import LoginCat from "../../styles/images/img_login_cat.png";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/slices/authSlice";
import { Modal } from "../../components/modal/Modal";
import useDidMountEffect from "../../components/hooks/useDidMountEffect";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";
const Login = () => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const modalMsg = useSelector((state) => state.auth.modalMsg);
  const [params, setParams] = useState({
    email: "",
    password: "",
    autologin: false,
  });
  const [autoLogin, setAutoLogin] = useState(false);

  const handleLogin = () => {
    dispatch(authActions.fetchLogin({ params }));
  };
  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);
  return (
    <OnlyHeaderLayout title="로그인">
      {openModal && (
        <Modal setOpenModal={setOpenModal}>
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      <Section>
        <Content>
          <LoginTextDiv>
            <h3>
              안녕하세요.
              <br />
              뮤포인트입니다.
            </h3>
            <p>서비스 이용을 위해 로그인 해주세요.</p>
          </LoginTextDiv>
          <LoginInputsDiv>
            <div>
              <input
                type="email"
                placeholder="이메일 주소"
                name="email"
                value={params.email}
                onChange={(e) => {
                  setParams((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
            </div>
            <div>
              <input
                type="password"
                placeholder="비밀번호"
                name="password"
                value={params.password}
                onChange={(e) => {
                  setParams((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }));
                }}
              />
            </div>
          </LoginInputsDiv>
          <LoginOptions>
            <CheckBoxWrap>
              <input
                type="checkbox"
                name="autologin"
                id="autologin"
                checked={params.autologin}
                onChange={(e) => {
                  setParams((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.checked,
                  }));
                }}
              />
              <label htmlFor="autologin">자동 로그인</label>
            </CheckBoxWrap>
            <div>
              <NavLink to="/sign-up">회원가입</NavLink>
            </div>
          </LoginOptions>
          <FindOptions>
            <NavLink to="/find/id">아이디 찾기</NavLink>
            <OrBar />
            <NavLink to="/find/password">비밀번호 찾기</NavLink>
          </FindOptions>
        </Content>
        <Btns>
          <ButtonL onClick={handleLogin}>로그인</ButtonL>
        </Btns>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default Login;
const LoginTextDiv = styled(TextDiv)`
  padding-top: 7.5rem;
  h3 {
    color: ${({ theme }) => theme.color.purple_primary};
    font-size: 3rem;
    line-height: 3.4rem;
    text-align: left;
    position: relative;
    width: fit-content;
    font-family: NanumSquareB;

    &::after {
      display: block;
      content: "";
      width: 11.6rem;
      height: 13.3rem;
      background-image: url(${LoginCat});
      background-position: center;
      background-size: cover;
      position: absolute;
      right: -11.6rem;
      bottom: 3.4rem;
    }
  }

  p {
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.6rem;
    text-align: left;
    margin-top: 1rem;
  }
`;

const LoginInputsDiv = styled(InputsDiv)`
  margin-top: 5rem;

  & > div {
    margin-top: 4rem;
  }
`;

const LoginOptions = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  label,
  a {
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 1.4rem;
  }

  a {
    color: ${({ theme }) => theme.color.purple_secondary};
    text-decoration-line: underline;
    font-weight: 700;
  }

  input[type="checkbox"] + label::before {
    margin-right: 0.5rem;
  }
`;

const FindOptions = styled.div`
  text-align: center;
  margin-top: 5rem;
  font-size: 1.4rem;
  line-height: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;

  a {
    color: ${({ theme }) => theme.color.black};
    margin: 0 1rem;
  }
`;
